import { render, staticRenderFns } from "./CreateByLawsAndRegulationsForm.vue?vue&type=template&id=2856d287&scoped=true"
import script from "./CreateByLawsAndRegulationsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateByLawsAndRegulationsForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CreateByLawsAndRegulationsForm.vue?vue&type=style&index=0&id=2856d287&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856d287",
  null
  
)

export default component.exports